.dq{background:var(--palette-white);}